export const ACTION_TYPES = {
    REQUEST_REGISTER: 'REQUEST_REGISTER',
    RECEIVE_REGISTER: 'RECEIVE_REGISTER',
    RECEIVE_CHECKREGISTER: 'RECEIVE_CHECKREGISTER'
  };
  
  const initialState = { entity: null, isLoading: false, status: null };
  
  export const pengkinianDataActions = {
    updateCustomer: (data) => async (dispatch) => {
  
      dispatch({ type: ACTION_TYPES.REQUEST_REGISTER });
  
      const headers = {
        //"Content-Type": "application/json",                                                                                                
        "Access-Control-Origin": "*"
      }
  
      const url = `api/pengkinianData`;
      const dataForm = data;
      let formData = new FormData();
      
      //formData.append('PhotoKTP', data.PhotoKTP);
      //formData.append('Occupation', data.Occupation);
  
      for (var key in data) {
        formData.append(key, data[key]);
      }
  
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        processData: false,
        contentType: false,
        body: formData
      });
      const entity = await response.json();
  
      dispatch({ type: ACTION_TYPES.RECEIVE_REGISTER, entity });
    
    },

  };
  
  export const reducer = (state, action) => {
    state = state || initialState;
  
    switch (action.type) {
      case (ACTION_TYPES.REQUEST_REGISTER):
        return {
          ...state,
          isLoading: true
        };
      case (ACTION_TYPES.RECEIVE_REGISTER):
        return {
          ...state,
          isLoading: false,
          entity: action.entity
        }
      case (ACTION_TYPES.RECEIVE_CHECKREGISTER):
        return {
          ...state,
          isLoading: false,
          status: action.statusRegister
        }
      default:
        return state;
    }
  
  };
  


// WEBPACK FOOTER //
// ./src/store/PengkinianData.Reducer.js